import CategoryService from 'src/common/api/category.service';

export async function fetchAllCategories({ commit }) {
  const response = await CategoryService.getAll();
  if (response.status === 200) {
    commit('updateAllCategories', { categories: response.data });
  }
}

export async function flush({ commit }) {
  commit('flush');
}
